<template>
  <v-card>
    <v-container class="pa-0" fluid fill-height>
      <v-row no-gutters class="segmentos-conteudo">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col>
              <h3 class="whatsapp-card-title pl-4 pt-2">Disparar campanha para:</h3>
            </v-col>
          </v-row>
          <v-row v-if="localTargetingMode == 'SEGMENTED'" no-gutters>
            <v-col>
              <p class="whatsapp-card-text pl-4">
                Selecione os clientes que devem receber essa campanha. Só serão contabilizados na segmentação abaixo clientes que já realizaram o cadastro no
                seu WhatsApp.
              </p>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="pl-3">
              <v-radio-group v-model="localTargetingMode" dense hide-details class="mt-0 mb-3">
                <v-radio label="Todos os contatos" color="primary" value="ALL" />
                <!-- LOYALTY -->
                <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                  <template #activator="{ on }">
                    <v-radio disabled label="Contatos no clube" color="primary" value="LOYALTY" class="pb-2" />
                  </template>
                  <span>Não é possível realizar envios massivos apenas para contatos dentro do clube.</span>
                </mf-tooltip>
                <v-radio v-else label="Contatos no clube" color="primary" value="LOYALTY" />
                <!-- NON LOYALTY -->
                <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                  <template #activator="{ on }">
                    <v-radio disabled label="Contatos fora do clube" color="primary" value="NON_LOYALTY" class="pb-2" />
                  </template>
                  <span>Não é possível realizar envios massivos apenas para contatos fora do clube.</span>
                </mf-tooltip>
                <v-radio v-else label="Contatos fora do clube" color="primary" value="NON_LOYALTY" />
                <!-- SEGMENTED -->
                <mf-tooltip v-if="isExternalProvider" bottom max-width="250px">
                  <template #activator="{ on }">
                    <v-radio label="Segmentos" color="primary" value="SEGMENTED" class="pb-2" />
                  </template>
                  <span>Para evitar banimentos, envios segmentados são realizados a uma taxa de 60 mensagens por hora por disparador.</span>
                </mf-tooltip>
                <v-radio v-else label="Segmentos" color="primary" value="SEGMENTED" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="localTargetingMode == 'SEGMENTED'" no-gutters>
            <v-col class="px-4 pb-3">
              <publico-alvo :segmentos.sync="localChosenSegments" :is-offer-schedule-personalized="isOfferSchedulePersonalized" disable-segment-view />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="segmentos-informacao">
          <v-container class="pa-0" fluid fill-height justify-center align-center>
            <v-container v-if="$apollo.queries.numberOfClients.loading || forceLoading" class="pa-0 segmentos-informacao-loading">
              <v-progress-circular class="loader" indeterminate color="primary" />
            </v-container>
            <v-container v-else class="pa-0 segmentos-informacao-inner">
              <v-row no-gutters>
                <v-col>
                  <span class="whatsapp-highlighted">{{ contactsCount | localeString }}</span>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <span class="whatsapp-regular">{{ descriptionBody }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'
import { localeString } from '@/config/helpers.js'
import { DateTime } from 'luxon'

const QUERY_GET_SEGMENTS_NUMBER_OF_CLIENTS = gql`
  query GetSegmentsNumberOfClients($segments_ids: [ID!]!, $senders: [String]) {
    getSegmentsNumberOfClients(segments_ids: $segments_ids) {
      total
      whatsapp(senders: $senders)
    }
  }
`

export default {
  components: {
    PublicoAlvo: () => import('@/modules/campanhas/views/components/PublicoAlvo.vue'),
  },
  filters: {
    zeroWhenEmpty(value) {
      if (!value) return 0
      return value
    },
  },
  props: {
    senders: Array,
    chosenSegments: Array,
    totalContacts: Object,
    targetingMode: String,
    forceLoading: Boolean,
    isOfferSchedulePersonalized: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    numberOfClients: {
      total: 0,
      whatsapp: 0,
    },
    updating: false,
  }),
  computed: {
    isExternalProvider() {
      return this.$getAllowedModules()['external_whatsapp_provider']
    },
    localTargetingMode: {
      get() {
        return this.targetingMode
      },
      set(value) {
        this.$emit('update:targeting-mode', value)
        this.$emit('update:estimated-max-messages', this.contactsCount)
      },
    },
    localChosenSegments: {
      get() {
        return this.chosenSegments
      },
      set(value) {
        this.$emit('update:chosenSegments', value)
      },
    },
    refreshedSegments() {
      return this.$store.getters.refreshedSegments
    },
    segmentsUpdating() {
      return this.$store.getters.updatingSegmentsIds
    },
    segmentUpdateMessage() {
      let upToDate = true
      this.localChosenSegments.forEach((segmento) => {
        if (DateTime.fromISO(segmento.clients_refreshed_at).toFormat('dd') < DateTime.now().toFormat('dd')) {
          upToDate = false
        }
      })
      if (this.localChosenSegments.length === 1) {
        return `O segmento selecionado está ${upToDate ? 'atualizado' : 'desatualizado'}.`
      }
      return `Os segmentos selecionados estão ${upToDate ? 'atualizados' : 'desatualizados'}.`
    },
    contactsCount() {
      switch (this.localTargetingMode) {
        case 'ALL':
          return this.totalContacts.total
        case 'LOYALTY':
          return this.totalContacts.loyalty
        case 'NON_LOYALTY':
          return this.totalContacts.non_loyalty
        case 'SEGMENTED':
          return this.numberOfClients?.whatsapp
      }
      return ''
    },
    descriptionBody() {
      switch (this.localTargetingMode) {
        case 'ALL':
          return 'que formam a base total de contatos do Whatsapp para os disparadores selecionados'
        case 'LOYALTY':
          return `dos ${localeString(this.totalContacts.total)} contatos do Whatsapp, fazem parte do clube de fidelidade`
        case 'NON_LOYALTY':
          return `dos ${localeString(this.totalContacts.total)} contatos do Whatsapp, não fazem parte do clube de fidelidade`
        case 'SEGMENTED':
          return `dos ${localeString(this.numberOfClients.total)} clientes segmentados, são contatos dos números selecionados`
      }
      return ''
    },
  },
  apollo: {
    numberOfClients: {
      query: QUERY_GET_SEGMENTS_NUMBER_OF_CLIENTS,
      notifyOnNetworkStatusChange: true,
      variables() {
        return {
          segments_ids: this.localChosenSegments.map((segment) => segment._id),
          senders: this.senders,
        }
      },
      skip() {
        if (!this.localChosenSegments || !this.localChosenSegments.length) return true
        return false
      },
      update({ getSegmentsNumberOfClients }) {
        if (getSegmentsNumberOfClients) {
          this.$emit('update:estimated-max-messages', getSegmentsNumberOfClients.whatsapp)
        }
        return getSegmentsNumberOfClients
      },
      fetchPolicy: 'no-cache',
    },
  },
  watch: {
    segmentsUpdating(value) {
      this.updating = value.length > 0

      this.localChosenSegments = this.chosenSegments.map((segment) => {
        if (value.includes(segment._id)) {
          segment.updating = true
        } else {
          segment.updating = false
        }

        return segment
      })
    },
    refreshedSegments(refreshedSegments) {
      this.localChosenSegments = this.chosenSegments.map((segment) => {
        const index = refreshedSegments.findIndex((refreshedSegment) => refreshedSegment._id === segment._id)
        if (index > -1) {
          segment.clients_refreshed_at = refreshedSegments[index].clients_refreshed_at
          segment.clients_qty = refreshedSegments[index].clients_qty
          segment.updating = false
        }
        return segment
      })
      this.updating = false
    },
  },
  methods: {
    removeSegment(index) {
      this.localChosenSegments = this.chosenSegments.filter((segment, segmentIndex) => segmentIndex !== index)
    },
    updateSegments() {
      if (this.updating) return
      this.$store
        .dispatch(
          'updateSegments',
          this.localChosenSegments.map((segment) => segment._id)
        )
        .catch((error) => {
          console.log(error)
          this.$snackbar({
            message: 'Não foi possível atualizar o segmento, tente novamente mais tarde ou entre em contato com o suporte',
            snackbarColor: 'error',
          })
          this.updating = false
        })
    },
  },
}
</script>

<style lang="scss">
.segmentos-conteudo {
  height: 100%;
  .segmentos-informacao {
    background-color: $ilustracao-solid-5;
    z-index: 1;
    border-radius: 0px 4px 4px 0px;
    &::before {
      content: '';
      background-color: $ilustracao-solid-5;
      z-index: 1;
      position: absolute;
      height: 30px;
      top: calc(50% - 15px);
      transform: rotate(45deg);
      width: 30px;
      margin-left: -16px;
    }
    .segmentos-informacao-inner {
      margin: 20px 60px 20px 140px;
    }
    .segmentos-informacao-loading {
      width: 160px;
    }
  }
  .disabled {
    color: $cinza-0;
  }
}
</style>
